import UppyFactory from '../../../../factory/uppy';

const DesignFacade = require('../../../../facade/design/design');
const ImagesFactory = require('../../../../factory/images');
const RestrictionsFactory = require('../../../../factory/restrictions');

const BaseView = require('./abstract-type');
const template = require('./background-type.hbs');
const ElementListView = require('./element-list/view');

module.exports = BaseView.extend({
  type: 'background',

  selectSpecifyFolder: function () {
    document.querySelector('#element-restrictions-images').checked = false;
    document.querySelector('#element-restrictions-folder').checked = true;
    const sourceList = this.el.querySelector('.image-replacement-options');
    const folderList = this.el.querySelector('.image-replacement-folders');
    sourceList.classList.toggle('hidden', true);
    folderList.classList.toggle('hidden', false);
    this.imagesListView.removeAllElement();
    this.recalculateSectionHeight(
      document.querySelector('#element-restrictions-folder')
    );
  },

  toggleSectionEvent: function (event) {
    const option = event.currentTarget;

    if (option.checked && option.id === 'element-restrictions-images' && !this.imagesListView.getData().length) {
      this.imagesListView.addElement(ImagesFactory.getVersionUrl(this.selection.source, 'thumb'));
      const folderList = this.el.querySelector('.image-replacement-folders');
      folderList.classList.toggle('hidden', true);
    }

    if (option.checked && option.id === 'element-restrictions-folder') this.selectSpecifyFolder();

    if (option.checked && option.id === 'element-restrictions-colors') {
      const colorsLibrary = this.el.querySelector('#element-restrictions-colors-library');

      this.colorsListView.getData().length || this.colorsListView.addElement(this.selection.color);
      colorsLibrary.checked = false;
      this._toggleSectionDisabled(colorsLibrary);
      this.onSectionChange(colorsLibrary);
    }

    if (option.checked && option.id === 'element-restrictions-colors-library') {
      const colors = this.el.querySelector('#element-restrictions-colors');

      this.colorsLibraryView.setLibraryPaletteRestriction({ palette: 0 });
      colors.checked = false;
      this._toggleSectionDisabled(colors);
      this.onSectionChange(colors);
    }

    this._toggleSectionDisabled(option);
    this.recalculateSectionHeight(option);

    BaseView.prototype.toggleSectionEvent.apply(this, arguments);
  },

  remove: function () {
    if (this.folderRestrictionView) {
      this.folderRestrictionView.closeApp();
    }
  },

  _toggleSectionDisabled: function (option) {
    const sectionName = option.closest('.restrictions.group').getAttribute('data-name') || 'basic';
    const name = option.getAttribute('name') || option.closest('.restrictions.group[data-field]')?.getAttribute('data-field');
    const value = this.getOptionValue($(option));

    sectionName === 'basic'
      ? this._toggleBasicSectionDisabled(name, value)
      : this._toggleImageColorSectionDisabled(sectionName, value);
  },

  _toggleBasicSectionDisabled: function (name, value) {
    name === 'image' && this._toggleImage(value);
    name === 'color' && this._toggleColors(value);
  },

  _toggleImage: function (value) {
    const imagesSection = this.el.querySelector('div[data-name="images"]');
    const specialImageInput = imagesSection.querySelector('#element-restrictions-images');
    const folder = this.el.querySelector('div[data-name="folder"]');
    const folderList = this.el.querySelector('.image-replacement-folders');
    const folderImageInput = this.el.querySelector('#element-restrictions-folder');

    imagesSection.classList.toggle('hidden', !value);
    folder.classList.toggle('hidden', !value);
    this.el.querySelector('.replacement-options').classList.toggle('hidden', true);
    folderList.classList.toggle('hidden', true);
    specialImageInput.checked = false;
    folderImageInput.checked = false;
    value || this.imagesListView.removeAllElement();
    value && this.initAddButton();
    this.onSectionChange(specialImageInput);
  },

  _toggleColors: function (value) {
    const colors = this.el.querySelector('#element-restrictions-colors');
    const colorsLibrary = this.el.querySelector('#element-restrictions-colors-library');

    this.el.querySelector('div[data-name="colors"]').classList.toggle('hidden', !value);
    this.el.querySelector('div[data-name="colors-library"]').classList.toggle('hidden', !value);

    if (value) return;

    this.el.querySelector('.color-replacement-options').classList.toggle('hidden', true);
    this.el.querySelector('.palette-replacement-options').classList.toggle('hidden', true);
    colors.checked = false;
    colorsLibrary.checked = false;
    this.colorsListView.removeAllElement();
    this.onSectionChange(colors);
    this.onSectionChange(colorsLibrary);
  },

  _toggleImageColorSectionDisabled: function (sectionName, value) {
    if (sectionName === 'images') {
      this.el.querySelector('.replacement-options').classList.toggle('hidden', !value);
      value || this.imagesListView.removeAllElement();
      value && this.initAddButton();
    } else if (sectionName === 'colors') {
      this.el.querySelector('.color-replacement-options').classList.toggle('hidden', !value);
      value || this.colorsListView.removeAllElement();
    } else if (sectionName === 'colors-library') {
      this.el.querySelector('.palette-replacement-options').classList.toggle('hidden', !value);
    }
  },

  render: async function (group) {
    document.addEventListener('updateRestriction', _.bind(this.updateImageRestrictions, this));
    this.$el.html(template());

    this.initImagesList();
    this.initColorsList();
    this.initLibraryColors();
    this.renderRestrictions();
    this.renderDisabled();
    this.initAddButton();
    await this.initLibraryFolders('image');
  },

  initImagesList: function () {
    this.imagesListView && this.imagesListView.remove();
    this.imagesListView = new ElementListView({
      el: this.$el.find('.image-replacement-options li'),
      type: 'background',
      uuid: 'background'
    });

    this.imagesListView.on('change', _.bind(
      this.elementListChange, this, this.imagesListView
    ));

    this.imagesListView.on('apply', function (url) {
      DesignFacade.set('background', { source: url });
    });
  },

  getOptionValue: function ($option) {
    if ($option.is('.element-list')) {
      return $option.data('uuid') === 'background'
        ? this.imagesListView.getData()
        : this.colorsListView.getData();
    }

    return BaseView.prototype.getOptionValue.apply(this, arguments);
  },

  _renderRestrictions: function (restrictions, sectionName) {
    if (sectionName === 'images' && restrictions[sectionName]) {
      _(restrictions[sectionName].list).each(this.imagesListView.addElement);
    }

    if (sectionName === 'folder' && restrictions.images && restrictions.images.library_folder) {
      setTimeout(() => this.selectSpecifyFolder(), 150);
    }

    if (sectionName === 'colors' && restrictions[sectionName]) {
      _(restrictions[sectionName].list).each(this.colorsListView.addElement);
    }

    if (sectionName === 'colors-library' && restrictions[sectionName]) {
      this.colorsLibraryView.setLibraryPaletteRestriction(restrictions[sectionName]);
    }

    BaseView.prototype._renderRestrictions.apply(this, arguments);
  },

  renderDisabled: function () {
    this._renderImageDisabled();
    this._renderColorDisabled();
  },

  _renderImageDisabled: function () {
    const replaceImageInput = document.querySelector('#element-restrictions-image-content');

    if (!replaceImageInput) return;

    const isReplaceOn = this.getOptionValue($(replaceImageInput));
    const replaceImageSubInput = document.querySelector('#element-restrictions-images');
    this.el.querySelector('div[data-name="images"] .element-restriction-sub-options').parentNode.classList.toggle('hidden', !isReplaceOn);

    if (!replaceImageSubInput) return;

    const isReplaceSpecifiedOn = this.getOptionValue($(replaceImageSubInput));
    this.el.querySelector('.image-replacement-options').classList.toggle('hidden', !(isReplaceOn && isReplaceSpecifiedOn));
    replaceImageInput && this.el.querySelector('div[data-name="folder"]').classList.toggle('hidden', !isReplaceOn);
  },

  _renderColorDisabled: function () {
    const replaceColorInput = document.querySelector('#element-restrictions-color-content');

    if (!replaceColorInput) return;

    const replaceColorSubInput = document.querySelector('#element-restrictions-colors');
    const replaceColorPaletteSubInput = document.querySelector('#element-restrictions-colors-library');
    const isReplaceOn = this.getOptionValue($(replaceColorInput));
    this.el.querySelector('div[data-name="colors"]').classList.toggle('hidden', !isReplaceOn);
    this.el.querySelector('div[data-name="colors-library"]').classList.toggle('hidden', !isReplaceOn);

    if (!replaceColorSubInput) return;

    const isReplaceSpecifiedColorOn = this.getOptionValue($(replaceColorSubInput));
    this.el.querySelector('.color-replacement-options').classList.toggle('hidden', !(isReplaceOn && isReplaceSpecifiedColorOn));

    if (!replaceColorPaletteSubInput) return;

    const isReplaceSpecifiedPaletteOn = this.getOptionValue($(replaceColorPaletteSubInput));
    this.el.querySelector('.palette-replacement-options').classList.toggle('hidden', !(isReplaceOn && isReplaceSpecifiedPaletteOn));
  },

  updateImageRestrictions: async function (data) {
    const ePermissions = await RestrictionsFactory.getElementPermissions();
    const permission = ePermissions.find(permission => {
      return permission.page_number === INKIVE.Tool._current_page_number &&
        permission.element_id === this.selection.id;
    });
    const restrictions = permission ? JSON.parse(permission.restrictions) : {};

    if (restrictions.images && restrictions.images.list) {
      const imageIncluded = restrictions.images.list.map((source) => ImagesFactory.getVersionUrl(source, 'thumb')).includes(data.tempLink);

      if (imageIncluded) return;

      INKIVE.Tool.getInstance().editor.canvas.call('advice.show', 'source-restriction-applied');
      restrictions.images.list.push(data.tempLink);
      RestrictionsFactory.setGlobalElementRestriction(
        this.selection.id, JSON.stringify(restrictions)
      );

      for (const source of restrictions.images.list) {
        this.imagesListView.addElement(source);
      }
    }

    this.recalculateSectionHeight(document.querySelector('#element-restrictions-image-content'));
    this.initAddButton();
  },

  initAddButton: function () {
    const addButton = this.el.querySelector('.replacement-options ul.options li .thumbnails-wrapper .add-new');

    const opts = {
      restrictions: {
        allowedFileTypes: ['image/png', 'image/jpeg']
      },
      onFileUploaded: this.updateImageRestrictions.bind(this)
    };

    this.uppyFactory = new UppyFactory({
      id: `uppy-library-${this.type}`,
      button: addButton,
      loadtype: this.type,
      restrictions: opts.restrictions,
      onFileUploaded: opts.onFileUploaded
    });

    this.uppyFactory.initUppyManager();
  }
});
